export const isUserSignedIn = punditUser => !!punditUser?.currentUser?.id;
